const announcements = [
    {name: "Manasvi: STEM Mentorship Program", url: "/notices/Manasvi.pdf"},
    {name: "Sci-Tech Spins Lecture", url: "/notices/STS.pdf"},
    {name: "Changemakers", url: "/notices/Changemakers.pdf"},
]

export default announcements;